import type {TicketTagDescriptionParams, TicketTagDescriptionResponse} from './types';

import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getTickets = createAsyncThunk<any, any>('getTickets', async (params, thunkApi) => {
  try {
    const response = await api.get(`/dasht/ticketing/ticket`, {
      params,
      paramsSerializer: {
        indexes: null
      },
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const getTicket = createAsyncThunk<any, any>('getTicket', async (params, thunkApi) => {
  try {
    const response = await api.get(
      `/dasht/ticketing/ticket/${params.ticket_id}?vendor_id=${params.vendor_id}`,
      {
        goBaseUrl: true
      }
    );
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const newTicket = createAsyncThunk<any, any>('newTicket', async (data, thunkApi) => {
  try {
    const response = await api.post(`/dasht/ticketing/ticket?vendor_id=${data.vendor_id}`, data, {
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const addTicketComment = createAsyncThunk<any, any>(
  'addTicketComment',
  async (data, thunkApi) => {
    try {
      const response = await api.post(
        `/dasht/ticketing/ticket/${data.ticket_id}/comment?vendor_id=${data.vendor_id}`,
        data,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getTags = createAsyncThunk<any, any>('getTags', async (params, thunkApi) => {
  try {
    const response = await api.get(`/dasht/ticketing/tag`, {
      params,
      paramsSerializer: {
        indexes: null
      },
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const getTagDescription = createAsyncThunk<
  TicketTagDescriptionResponse,
  TicketTagDescriptionParams
>('ticket/getTagDescription', async ({tag_id, vendor_id}, thunkApi) => {
  try {
    const response = await api.get<TicketTagDescriptionResponse>(
      `/dasht/ticketing/tag/${tag_id}/description`,
      {params: {vendor_id}, goBaseUrl: true, signal: thunkApi.signal}
    );
    const payload = response.data;
    if (
      payload?.status !== true ||
      !payload.data ||
      (payload.data.description !== null && typeof payload.data.description !== 'string')
    ) {
      return thunkApi.rejectWithValue('Invalid tag description response');
    }
    return thunkApi.fulfillWithValue(payload);
  } catch {
    return thunkApi.rejectWithValue('Failed to load tag description');
  }
});

export const uploadFiles = createAsyncThunk<any, any>('uploadFiles', async (data, thunkApi) => {
  try {
    const response = await api.post(`/dasht/ticketing/attachment?vendor_id=${data.id}`, data.file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e || 'خطا در آپلود');
  }
});

export const downloadAttachment = createAsyncThunk<any, any>(
  'downloadAttachment',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `/dasht/ticketing/attachment/${params.id}?vendor_id=${params.vendor_id}`,
        {
          goBaseUrl: true,
          responseType: 'blob'
        }
      );
      return thunkApi.fulfillWithValue({data: response.data, headers: response.headers});
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
